// src/pages/IndoorMap/routeAssets.js
import { ReactComponent as RouteExperienceZoneFoodRadio } from "../../assets/svg/routes2/experience-zone__food-radio.svg"
import { ReactComponent as RouteExperienceZoneMainHall } from "../../assets/svg/routes2/experience-zone__main-hall.svg"
import { ReactComponent as RouteExperienceZoneValet } from "../../assets/svg/routes2/experience-zone__valet.svg"
import { ReactComponent as RouteFoodRadioMainHall } from "../../assets/svg/routes2/food-radio__main-hall.svg"
import { ReactComponent as RouteFoodRadioValet } from "../../assets/svg/routes2/food-radio__valet.svg"
import { ReactComponent as RouteMainHallValet } from "../../assets/svg/routes2/main-hall__valet.svg"

export const ROUTE_COMPONENTS = {
  "experience-zone__food-radio": RouteExperienceZoneFoodRadio,
  "experience-zone__main-hall": RouteExperienceZoneMainHall,
  "experience-zone__valet": RouteExperienceZoneValet,
  "food-radio__main-hall": RouteFoodRadioMainHall,
  "food-radio__valet": RouteFoodRadioValet,
  "main-hall__valet": RouteMainHallValet,
}

export const getRouteKey = (a, b) => [a, b].sort().join("__")

export function resolveRoute(startId, endId) {
  if (!startId || !endId || startId === endId) return null
  const key = getRouteKey(startId, endId)
  const Component = ROUTE_COMPONENTS[key]
  return Component ? { Component, swapped: key !== `${startId}__${endId}` } : null
}